import { FEATURE_FLAGS } from './constants';

interface IReducerState {
  featureFlags: typeof FEATURE_FLAGS;
}

export function getFeatureFlags(state: IReducerState): typeof FEATURE_FLAGS {
  return state.featureFlags;
}
